export interface DynamicBannerConfiguration {
  deviceConfig: DeviceFlags;
  templateType?: string;
}

export interface DeviceFlags {
  desktopEnabled?: boolean;
  mobileEnabled?: boolean;
  responsive?: boolean;
}
